import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { CancelManyTransportActions } from "store/ducks/transports";

export function* cancelManyTransportRequest(action: any) {
  try {
    const { putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/transports/cancel-many`,
      putData
    );

    const { data } = responseBody;
    yield put(CancelManyTransportActions.success(data));
    notify("success", "Cargas canceladas com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CancelManyTransportActions.failure(errorMessage));
  }
}
